/* Deckaura free-tarot card themes.
   One card-specific traditional meaning for every card in every published
   non-English storefront language. The canonical 78-card order is shared
   with deckaura-tarot-data.js. */
(function () {
  'use strict';

  var THEMES = {
    tr: [
      'Yeni başlangıçlar, masumiyet, doğallık ve özgür ruh.',
      'Niyetini gerçeğe dönüştürme, beceri, yaratıcılık ve harekete geçme gücü.',
      'Sezgi, içsel bilgi, gizem ve bilinçaltında şekillenen farkındalık.',
      'Bolluk, yaratıcılık, şefkatli bakım ve somutlaşan büyüme.',
      'Yapı, otorite, net standartlar ve istikrarlı liderlik.',
      'Gelenek, öğretmenlik, ortak değerler ve yerleşik bilgelik.',
      'Uyum, ilişkiler, kişisel değerler ve anlamlı bir seçim.',
      'Yön, irade, ivme ve disiplinli hareket.',
      'Cesaret, şefkat, sabır ve sakin bir etki gücü.',
      'İçe dönüş, yalnızlık, içsel rehberlik ve dikkatli arayış.',
      'Döngüler, değişim, dönüm noktaları ve değişen koşullar.',
      'Gerçek, adalet, sorumluluk ve neden-sonuç ilişkisi.',
      'Duraklama, teslimiyet, farklı bakış açısı ve amaçlı bekleyiş.',
      'Bitişler, dönüşüm, geçiş ve yenilenme.',
      'Denge, bütünleşme, sabır ve sürdürülebilir ilerleme.',
      'Bağlılık, arzu, gölge örüntüleri ve kısıtlanma.',
      'Açığa çıkış, sarsıntı, ani değişim ve temellerin görünür olması.',
      'Umut, yenilenme, amaç ve sakin bir ilham.',
      'Belirsizlik, sezgi, hayal gücü ve bilinçaltı.',
      'Neşe, açıklık, canlılık ve görünür başarı.',
      'Değerlendirme, uyanış, yenilenme ve içten gelen çağrı.',
      'Tamamlanma, bütünleşme, başarı ve bütünlük.',

      'Duygusal bir açılma, yeni hisler, yaratıcılık ve sezgi.',
      'Karşılıklılık, ortaklık, bağ kurma ve dengeli alışveriş.',
      'Kutlama, dostluk, yaratıcılık ve topluluk desteği.',
      'İçe dönüp değerlendirme, isteksizlik ve gözden kaçan bir seçenek.',
      'Pişmanlık, yas, hayal kırıklığı ve kaybedilene odaklanma.',
      'Anılar, nostalji, masumiyet ve geçmişin geri dönüşü.',
      'Seçenekler, hayal gücü, fantezi ve netleşmemiş öncelikler.',
      'Artık doyurmayanı geride bırakma ve daha derin bir anlam arayışı.',
      'Tatmin, minnettarlık, haz ve şekillenmeye başlayan bir dilek.',
      'Uyum, aidiyet, ortak değerler ve duygusal doyum.',
      'İçten bir mesaj, merak, yaratıcı olasılık ve sezgi.',
      'Romantizm, hayal gücü, davet ve kalbin yön verdiği hareket.',
      'Empati, duygusal zekâ, sezgi ve şefkatli bakım.',
      'Duygusal olgunluk, diplomasi, denge ve sakin liderlik.',

      'Somut bir başlangıç, fırsat, kaynaklar ve istikrarlı potansiyel.',
      'Uyum sağlama, zaman yönetimi ve birbiriyle yarışan öncelikleri dengeleme.',
      'Ekip çalışması, öğrenme, ustalık ve uygulamaya geçirme.',
      'Güvenlik, sınırlar, kaynakları koruma ve sıkı tutunma.',
      'Zorluk, dışlanma, kaygı ve kıtlık düşüncesi.',
      'Verme, alma, cömertlik ve dengeli alışveriş.',
      'Sabır, yatırım, değerlendirme ve sürdürülebilir büyüme.',
      'Pratik, ustalaşma, adanmışlık ve beceri geliştirme.',
      'Bağımsızlık, bolluk, öz değer ve emekle kazanılmış rahatlık.',
      'Miras, uzun vadeli güvenlik, aile ve kalıcı başarı.',
      'Öğrenme, somut fırsat, hedef ve öğretici bir başlangıç.',
      'Güvenilirlik, düzen, sabır ve yöntemli ilerleme.',
      'Ayakları yere basan bakım, somut destek ve becerikli liderlik.',
      'İş zekâsı, güvenilirlik, disiplin ve maddi ustalık.',

      'Netlik, gerçek, zihinsel atılım ve kararlı anlayış.',
      'Zor bir seçim, çıkmaz ve dengede tutulan bilgiler.',
      'Kalp acısı, hayal kırıklığı, ayrılık ve acı veren gerçek.',
      'Dinlenme, düşünme, toparlanma ve stratejik duraklama.',
      'Çatışma, rekabet ve aşırı bedelli bir zafer.',
      'Geçiş, hareket, bırakma ve daha sakin koşullara ilerleme.',
      'Strateji, gizlilik, bağımsızlık ve paylaşılmayan bilgiler.',
      'Kısıtlanma, sınırlayıcı inançlar ve gerçekte olduğundan dar görünen seçenekler.',
      'Kaygı, zihinsel döngüler, endişe ve en kötü ihtimali büyütme.',
      'Bir son, sınırına ulaşma ve acı veren bir kapanış.',
      'Sorular, merak, dikkatli iletişim ve yeni fikirler.',
      'Hırs, doğrudan hareket, hız ve kararlı iletişim.',
      'Ayırt etme gücü, bağımsızlık, sınırlar ve açık iletişim.',
      'Akıl, etik otorite, zihinsel açıklık ve adil yargı.',

      'İlham, potansiyel, girişim ve yaratıcı bir kıvılcım.',
      'Planlama, vizyon, keşif ve sonraki yönü belirleme.',
      'Genişleme, ilerleme, öngörü ve hareketlenmeye başlayan sonuçlar.',
      'Kutlama, aidiyet, uyum ve sağlam bir dönüm noktası.',
      'Sürtüşme, rekabet, farklı görüşler ve yaratıcı gerilim.',
      'Tanınma, ilerleme, özgüven ve görünür başarı.',
      'Mücadele, korunma, kararlılık ve bulunduğun konumu savunma.',
      'Hız, mesajlar, hareket ve hızlı gelişmeler.',
      'Dayanıklılık, sınırlar, sebat ve temkinli cesaret.',
      'Yük, sorumluluk, yoğun emek ve aşırı yüklenmiş bir bitiriş.',
      'Keşif, heves, yenilik ve erken bir yaratıcı işaret.',
      'Tutku, macera, girişim ve cesur hareket.',
      'Özgüven, sıcaklık, bağımsızlık ve çekim gücü yüksek yaratıcılık.',
      'Vizyon, liderlik, girişimcilik ve cesur kararlar.'
    ],

    es: [
      'Nuevos comienzos, inocencia, espontaneidad y espíritu libre.',
      'Manifestación, ingenio, habilidad y acción inspirada.',
      'Intuición, conocimiento interior, misterio y subconsciente.',
      'Abundancia, creatividad, cuidado y crecimiento encarnado.',
      'Estructura, autoridad, criterios claros y liderazgo estable.',
      'Tradición, enseñanza, valores compartidos y sabiduría establecida.',
      'Alineación, relaciones, valores y una elección significativa.',
      'Dirección, voluntad, impulso y acción disciplinada.',
      'Valor, compasión, paciencia e influencia serena.',
      'Reflexión, soledad, guía interior y búsqueda cuidadosa.',
      'Ciclos, cambio, puntos de giro y condiciones variables.',
      'Verdad, justicia, responsabilidad y causa y efecto.',
      'Pausa, entrega, perspectiva y espera con propósito.',
      'Finales, transformación, transición y renovación.',
      'Equilibrio, integración, paciencia y progreso sostenible.',
      'Apego, deseo, patrones de sombra y restricción.',
      'Revelación, ruptura, cambio repentino y cimientos expuestos.',
      'Esperanza, renovación, propósito e inspiración serena.',
      'Incertidumbre, intuición, imaginación y subconsciente.',
      'Alegría, apertura, vitalidad y éxito visible.',
      'Revisión, despertar, renovación y una llamada sincera.',
      'Culminación, integración, logro y plenitud.',

      'Apertura emocional, sentimientos nuevos, creatividad e intuición.',
      'Reciprocidad, colaboración, conexión e intercambio equilibrado.',
      'Celebración, amistad, creatividad y comunidad.',
      'Contemplación, reevaluación, apatía y una opción ignorada.',
      'Arrepentimiento, duelo, decepción y atención a lo perdido.',
      'Memoria, nostalgia, inocencia y regreso del pasado.',
      'Opciones, imaginación, fantasía y prioridades poco claras.',
      'Alejarse de lo que ya no nutre y buscar un sentido más profundo.',
      'Satisfacción, gratitud, placer y un deseo que toma forma.',
      'Armonía, pertenencia, valores compartidos y plenitud emocional.',
      'Un mensaje sensible, curiosidad, posibilidad creativa e intuición.',
      'Romance, imaginación, invitación y movimiento guiado por el corazón.',
      'Empatía, inteligencia emocional, intuición y cuidado compasivo.',
      'Madurez emocional, diplomacia, equilibrio y liderazgo sereno.',

      'Comienzo práctico, oportunidad, recursos y potencial estable.',
      'Adaptación, gestión del tiempo y equilibrio entre prioridades.',
      'Trabajo en equipo, aprendizaje, oficio y puesta en práctica.',
      'Seguridad, límites, conservación y necesidad de retener.',
      'Dificultad, exclusión, preocupación y mentalidad de escasez.',
      'Dar, recibir, generosidad e intercambio equilibrado.',
      'Paciencia, inversión, evaluación y crecimiento sostenible.',
      'Práctica, dominio, dedicación y desarrollo de habilidades.',
      'Independencia, abundancia, autoestima y bienestar ganado.',
      'Legado, seguridad a largo plazo, familia y éxito duradero.',
      'Estudio, oportunidad práctica, ambición y comienzo formativo.',
      'Fiabilidad, rutina, paciencia y progreso metódico.',
      'Cuidado realista, apoyo práctico y liderazgo resolutivo.',
      'Criterio empresarial, fiabilidad, disciplina y dominio material.',

      'Claridad, verdad, avance mental y comprensión decisiva.',
      'Elección difícil, bloqueo e información mantenida en equilibrio.',
      'Dolor, decepción, separación y una verdad difícil.',
      'Descanso, contemplación, recuperación y pausa estratégica.',
      'Conflicto, competencia y victoria con un coste excesivo.',
      'Transición, movimiento, liberación y paso hacia condiciones más serenas.',
      'Estrategia, privacidad, independencia e información no compartida.',
      'Restricción, creencias limitantes y opciones que parecen menores de lo que son.',
      'Ansiedad, rumiación, preocupación e imaginación del peor resultado.',
      'Final, límite alcanzado y conclusión dolorosa.',
      'Preguntas, curiosidad, comunicación alerta e ideas nuevas.',
      'Ambición, acción directa, rapidez y comunicación decisiva.',
      'Discernimiento, independencia, límites y comunicación clara.',
      'Razón, autoridad ética, claridad mental y juicio justo.',

      'Inspiración, potencial, iniciativa y chispa creativa.',
      'Planificación, visión, descubrimiento y elección del próximo rumbo.',
      'Expansión, progreso, previsión y resultados que empiezan a avanzar.',
      'Celebración, pertenencia, armonía y un hito estable.',
      'Fricción, competencia, opiniones diversas y tensión creativa.',
      'Reconocimiento, progreso, confianza y éxito visible.',
      'Desafío, protección, perseverancia y defensa de una posición.',
      'Rapidez, mensajes, movimiento y desarrollo acelerado.',
      'Resiliencia, límites, persistencia y valor prudente.',
      'Carga, responsabilidad, trabajo duro y final sobrecargado.',
      'Exploración, entusiasmo, descubrimiento y primera señal creativa.',
      'Pasión, aventura, iniciativa y movimiento audaz.',
      'Confianza, calidez, independencia y creatividad magnética.',
      'Visión, liderazgo, emprendimiento y decisiones audaces.'
    ],

    de: [
      'Neuanfang, Unschuld, Spontaneität und ein freier Geist.',
      'Manifestation, Einfallsreichtum, Können und inspiriertes Handeln.',
      'Intuition, inneres Wissen, Geheimnis und Unterbewusstsein.',
      'Fülle, Kreativität, Fürsorge und verkörpertes Wachstum.',
      'Struktur, Autorität, klare Maßstäbe und stabile Führung.',
      'Tradition, Lehre, gemeinsame Werte und bewährte Weisheit.',
      'Ausrichtung, Beziehungen, Werte und eine bedeutsame Wahl.',
      'Richtung, Willenskraft, Schwung und diszipliniertes Handeln.',
      'Mut, Mitgefühl, Geduld und stille Einflusskraft.',
      'Reflexion, Rückzug, innere Führung und sorgfältige Suche.',
      'Zyklen, Veränderung, Wendepunkte und wechselnde Bedingungen.',
      'Wahrheit, Fairness, Verantwortung und Ursache und Wirkung.',
      'Pause, Hingabe, Perspektive und bewusstes Warten.',
      'Enden, Wandlung, Übergang und Erneuerung.',
      'Balance, Integration, Geduld und nachhaltiger Fortschritt.',
      'Bindung, Begehren, Schattenmuster und Einschränkung.',
      'Enthüllung, Umbruch, plötzlicher Wandel und freigelegte Fundamente.',
      'Hoffnung, Erneuerung, Sinn und ruhige Inspiration.',
      'Ungewissheit, Intuition, Vorstellungskraft und Unterbewusstsein.',
      'Freude, Offenheit, Lebenskraft und sichtbarer Erfolg.',
      'Rückschau, Erwachen, Erneuerung und eine ehrliche Berufung.',
      'Vollendung, Integration, Leistung und Ganzheit.',

      'Emotionale Öffnung, neue Gefühle, Kreativität und Intuition.',
      'Gegenseitigkeit, Partnerschaft, Verbindung und ausgewogener Austausch.',
      'Feier, Freundschaft, Kreativität und Gemeinschaft.',
      'Betrachtung, Neubewertung, Teilnahmslosigkeit und eine übersehene Möglichkeit.',
      'Bedauern, Trauer, Enttäuschung und der Blick auf das Verlorene.',
      'Erinnerung, Nostalgie, Unschuld und die Rückkehr der Vergangenheit.',
      'Möglichkeiten, Fantasie, Wunschbilder und unklare Prioritäten.',
      'Abschied von dem, was nicht mehr erfüllt, und Suche nach tieferem Sinn.',
      'Zufriedenheit, Dankbarkeit, Genuss und ein Wunsch, der Gestalt annimmt.',
      'Harmonie, Zugehörigkeit, gemeinsame Werte und emotionale Erfüllung.',
      'Eine einfühlsame Botschaft, Neugier, kreative Möglichkeit und Intuition.',
      'Romantik, Vorstellungskraft, Einladung und vom Herzen geführte Bewegung.',
      'Empathie, emotionale Intelligenz, Intuition und mitfühlende Fürsorge.',
      'Emotionale Reife, Diplomatie, Balance und ruhige Führung.',

      'Praktischer Anfang, Chance, Ressourcen und stabiles Potenzial.',
      'Anpassungsfähigkeit, Zeitmanagement und Ausgleich konkurrierender Prioritäten.',
      'Teamarbeit, Lernen, Handwerkskunst und Umsetzung.',
      'Sicherheit, Grenzen, Bewahrung und festes Festhalten.',
      'Notlage, Ausschluss, Sorge und ein Denken in Mangel.',
      'Geben, Empfangen, Großzügigkeit und ausgewogener Austausch.',
      'Geduld, Investition, Bewertung und nachhaltiges Wachstum.',
      'Übung, Meisterschaft, Hingabe und Kompetenzentwicklung.',
      'Unabhängigkeit, Fülle, Selbstwert und verdienter Komfort.',
      'Vermächtnis, langfristige Sicherheit, Familie und dauerhafter Erfolg.',
      'Studium, praktische Chance, Ehrgeiz und ein lernbereiter Anfang.',
      'Verlässlichkeit, Routine, Geduld und methodischer Fortschritt.',
      'Bodenständige Fürsorge, praktische Unterstützung und einfallsreiche Führung.',
      'Geschäftssinn, Verlässlichkeit, Disziplin und materielle Meisterschaft.',

      'Klarheit, Wahrheit, Durchbruch und entschlossenes Verstehen.',
      'Schwierige Wahl, Stillstand und in Balance gehaltene Informationen.',
      'Herzschmerz, Enttäuschung, Trennung und schmerzhafte Wahrheit.',
      'Ruhe, Betrachtung, Erholung und strategische Pause.',
      'Konflikt, Wettbewerb und ein Sieg zu einem zu hohen Preis.',
      'Übergang, Bewegung, Loslassen und der Weg in ruhigere Verhältnisse.',
      'Strategie, Privatsphäre, Unabhängigkeit und zurückgehaltene Informationen.',
      'Einschränkung, begrenzende Überzeugungen und Möglichkeiten, die kleiner wirken, als sie sind.',
      'Angst, Grübeln, Sorge und die Vorstellung des schlimmsten Ausgangs.',
      'Ein Ende, eine erreichte Grenze und ein schmerzhafter Abschluss.',
      'Fragen, Neugier, wache Kommunikation und neue Ideen.',
      'Ehrgeiz, direktes Handeln, Tempo und entschlossene Kommunikation.',
      'Urteilskraft, Unabhängigkeit, Grenzen und klare Kommunikation.',
      'Vernunft, ethische Autorität, geistige Klarheit und faires Urteil.',

      'Inspiration, Potenzial, Initiative und ein kreativer Funke.',
      'Planung, Vision, Entdeckung und die Wahl der nächsten Richtung.',
      'Expansion, Fortschritt, Weitblick und Ergebnisse, die in Bewegung kommen.',
      'Feier, Zugehörigkeit, Harmonie und ein stabiler Meilenstein.',
      'Reibung, Wettbewerb, verschiedene Ansichten und kreative Spannung.',
      'Anerkennung, Fortschritt, Selbstvertrauen und sichtbarer Erfolg.',
      'Herausforderung, Schutz, Ausdauer und das Verteidigen einer Position.',
      'Tempo, Nachrichten, Bewegung und schnelle Entwicklung.',
      'Widerstandskraft, Grenzen, Beharrlichkeit und vorsichtiger Mut.',
      'Last, Verantwortung, harte Arbeit und ein überfrachteter Abschluss.',
      'Erkundung, Begeisterung, Entdeckung und ein frühes kreatives Signal.',
      'Leidenschaft, Abenteuer, Initiative und mutige Bewegung.',
      'Selbstvertrauen, Wärme, Unabhängigkeit und magnetische Kreativität.',
      'Vision, Führung, Unternehmergeist und mutige Entscheidungen.'
    ],

    pt: [
      'Novos começos, inocência, espontaneidade e espírito livre.',
      'Manifestação, engenho, competência e ação inspirada.',
      'Intuição, conhecimento interior, mistério e subconsciente.',
      'Abundância, criatividade, cuidado e crescimento concreto.',
      'Estrutura, autoridade, critérios claros e liderança estável.',
      'Tradição, ensino, valores partilhados e sabedoria estabelecida.',
      'Alinhamento, relações, valores e uma escolha significativa.',
      'Direção, força de vontade, impulso e ação disciplinada.',
      'Coragem, compaixão, paciência e influência serena.',
      'Reflexão, recolhimento, orientação interior e procura cuidadosa.',
      'Ciclos, mudança, pontos de viragem e condições variáveis.',
      'Verdade, justiça, responsabilidade e causa e efeito.',
      'Pausa, entrega, perspetiva e espera com propósito.',
      'Finais, transformação, transição e renovação.',
      'Equilíbrio, integração, paciência e progresso sustentável.',
      'Apego, desejo, padrões de sombra e restrição.',
      'Revelação, rutura, mudança súbita e alicerces expostos.',
      'Esperança, renovação, propósito e inspiração tranquila.',
      'Incerteza, intuição, imaginação e subconsciente.',
      'Alegria, abertura, vitalidade e sucesso visível.',
      'Revisão, despertar, renovação e um chamamento sincero.',
      'Conclusão, integração, conquista e plenitude.',

      'Abertura emocional, novos sentimentos, criatividade e intuição.',
      'Reciprocidade, parceria, ligação e troca equilibrada.',
      'Celebração, amizade, criatividade e comunidade.',
      'Contemplação, reavaliação, apatia e uma opção ignorada.',
      'Arrependimento, luto, desilusão e atenção ao que se perdeu.',
      'Memória, nostalgia, inocência e regresso do passado.',
      'Opções, imaginação, fantasia e prioridades pouco claras.',
      'Afastamento do que já não satisfaz e procura de um sentido mais profundo.',
      'Satisfação, gratidão, prazer e um desejo a ganhar forma.',
      'Harmonia, pertença, valores partilhados e realização emocional.',
      'Uma mensagem sensível, curiosidade, possibilidade criativa e intuição.',
      'Romance, imaginação, convite e movimento guiado pelo coração.',
      'Empatia, inteligência emocional, intuição e cuidado compassivo.',
      'Maturidade emocional, diplomacia, equilíbrio e liderança serena.',

      'Início prático, oportunidade, recursos e potencial estável.',
      'Adaptação, gestão do tempo e equilíbrio entre prioridades concorrentes.',
      'Trabalho de equipa, aprendizagem, perícia e execução.',
      'Segurança, limites, conservação e apego ao que se possui.',
      'Dificuldade, exclusão, preocupação e mentalidade de escassez.',
      'Dar, receber, generosidade e troca equilibrada.',
      'Paciência, investimento, avaliação e crescimento sustentável.',
      'Prática, domínio, dedicação e desenvolvimento de competências.',
      'Independência, abundância, autoestima e conforto conquistado.',
      'Legado, segurança a longo prazo, família e sucesso duradouro.',
      'Estudo, oportunidade prática, ambição e começo formativo.',
      'Fiabilidade, rotina, paciência e progresso metódico.',
      'Cuidado realista, apoio prático e liderança engenhosa.',
      'Critério empresarial, fiabilidade, disciplina e domínio material.',

      'Clareza, verdade, avanço mental e compreensão decisiva.',
      'Escolha difícil, impasse e informação mantida em equilíbrio.',
      'Dor, desilusão, separação e uma verdade difícil.',
      'Descanso, contemplação, recuperação e pausa estratégica.',
      'Conflito, competição e vitória com um custo excessivo.',
      'Transição, movimento, libertação e passagem para condições mais tranquilas.',
      'Estratégia, privacidade, independência e informação não partilhada.',
      'Restrição, crenças limitadoras e opções que parecem menores do que são.',
      'Ansiedade, ruminação, preocupação e imaginação do pior resultado.',
      'Um fim, um limite atingido e uma conclusão dolorosa.',
      'Perguntas, curiosidade, comunicação atenta e novas ideias.',
      'Ambição, ação direta, rapidez e comunicação decisiva.',
      'Discernimento, independência, limites e comunicação clara.',
      'Razão, autoridade ética, clareza mental e julgamento justo.',

      'Inspiração, potencial, iniciativa e uma centelha criativa.',
      'Planeamento, visão, descoberta e escolha da próxima direção.',
      'Expansão, progresso, previsão e resultados que começam a avançar.',
      'Celebração, pertença, harmonia e um marco estável.',
      'Fricção, competição, opiniões diversas e tensão criativa.',
      'Reconhecimento, progresso, confiança e sucesso visível.',
      'Desafio, proteção, perseverança e defesa de uma posição.',
      'Rapidez, mensagens, movimento e desenvolvimento acelerado.',
      'Resiliência, limites, persistência e coragem prudente.',
      'Peso, responsabilidade, trabalho árduo e final sobrecarregado.',
      'Exploração, entusiasmo, descoberta e primeiro sinal criativo.',
      'Paixão, aventura, iniciativa e movimento audaz.',
      'Confiança, calor, independência e criatividade magnética.',
      'Visão, liderança, empreendedorismo e decisões audazes.'
    ]
  };

  var REVERSED = {
    tr: 'Ters yön, bu kartın özgün temalarının engellenmiş, gecikmiş, içe dönmüş veya yeniden değerlendiriliyor olabileceğini gösterir: {theme}',
    es: 'La posición invertida indica que los temas propios de esta carta pueden estar bloqueados, demorados, interiorizados o bajo revisión: {theme}',
    de: 'In umgekehrter Lage können die eigenen Themen dieser Karte blockiert, verzögert, nach innen gerichtet oder in Neubewertung sein: {theme}',
    pt: 'Na posição invertida, os temas próprios desta carta podem estar bloqueados, atrasados, interiorizados ou em reavaliação: {theme}'
  };

  function indexFor(card) {
    var numeric = Number(card && card.id);
    if (Number.isInteger(numeric) && numeric >= 0 && numeric < 78) return numeric;
    var cards = Array.isArray(window.DeckauraTarotCards) ? window.DeckauraTarotCards : [];
    var name = String(card && card.name || '');
    for (var index = 0; index < cards.length; index += 1) {
      if (String(cards[index] && cards[index].name || '') === name) return index;
    }
    return -1;
  }

  function meaning(card, language, reversed) {
    var pack = THEMES[String(language || '').toLowerCase()];
    var index = indexFor(card);
    if (!pack || pack.length !== 78 || index < 0 || !pack[index]) return '';
    var theme = String(pack[index]).trim();
    if (!reversed) return theme;
    return String(REVERSED[language] || REVERSED.pt).replace('{theme}', theme);
  }

  window.DeckauraFreeTarotCardThemes = {
    languages: ['tr', 'es', 'de', 'pt'],
    count: 78,
    themes: THEMES,
    meaning: meaning
  };
})();
